import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ChecklistStoreEffects } from './effects';
import { checklistReducer } from './reducer';

@NgModule({
  declarations: [],
  imports: [CommonModule, StoreModule.forFeature('Checklist', checklistReducer), EffectsModule.forFeature([ChecklistStoreEffects])],
  providers: [ChecklistStoreEffects],
})
export class ChecklistStoreModule {
  Checklist: any;
}
